import { isNumber } from 'utils/tsHelpers';
import { CountInputKey } from '../types';
import { CountFilterProps } from '../../types';

export const getOnInputChange = ({
  value,
  onChange,
}: Pick<CountFilterProps, 'value' | 'onChange'>) => {
  return (inputKey: CountInputKey) => {
    return (newInput: number | null) => {
      if (isNumber(newInput) && newInput < 1) return;
      onChange({ ...value, [inputKey]: newInput ?? undefined });
    };
  };
};
